import axios from 'axios'
import Router from '@/router/index'
import Vue from 'vue'
const v = new Vue()
const myaxios = axios.create({
  headers: {
    'content-type': 'application/json;charset=UTF-8',
    'token': 'one'
  },
  baseURL: '/api/',
  timeout: 60000,
  withCredentials: true
})

// 添加请求拦截器
myaxios.interceptors.request.use(config => {
  // 在发送请求之前做某事，比如说 设置token
  config.headers['token'] = 'token'
  config.headers['conferenceId'] = Router.app._route.params.co_id
  return config
}, error => {
  // 请求错误时做些事
  return Promise.reject(error)
})

// 添加响应拦截器
myaxios.interceptors.response.use(response => {
  // 对响应数据做些事
  if (response.status === 200) {
    if (response.data) {
      if (response.data.code === '1000' ||
        response.data.code === '1001' || response.data.code === '1002') {
        Router.push({name: 'login'})
      } else if (response.data.code === '1004' && response.data.message) {
        Router.push({name: 'login'})
        let locale = localStorage.getItem('language')
        let message = locale === 'zh' ? response.data.comment : response.data.message
        v.$alert(message, 'Message', {
          confirmButtonText: '关闭',
          type: 'error'
        })
        // v.$notify.error({
        //   title: 'Message',
        //   message: message
        // })
      } else if (response.data.code === '1005') {
        Router.push({name: 'paper'})
      } else if (response.data.code !== '0000' && response.data.message) {
        let locale = localStorage.getItem('language')
        let message = locale === 'zh' ? response.data.comment : response.data.message
        v.$alert(message, 'Message', {
          confirmButtonText: '关闭',
          type: 'error'
        })
        // v.$notify.error({
        //   title: 'Message',
        //   message: message
        // })
      }
    }
  }
  return response
}, error => {
  console.log(error)
  return Promise.reject(error) // 返回接口返回的错误信息
})

export default myaxios



// WEBPACK FOOTER //
// ./src/tool/http.js